const faqs = [
  {
    q: '7777影院是否需要注册才能观看？',
    a: '不需要。7777影院所有影视内容均无需注册即可免费在线观看，打开网站即可直接播放。注册账号后可享受收藏、历史记录、离线缓存等更多功能。',
    icon: 'ri-user-line',
  },
  {
    q: '视频播放卡顿或缓冲怎么办？',
    a: '7777影院采用智能CDN加速技术，通常情况下播放流畅不缓冲。如遇卡顿，可尝试切换播放线路（播放器右下角）或降低清晰度。建议使用Chrome或Safari浏览器获得最佳体验。',
    icon: 'ri-speed-up-line',
  },
  {
    q: '支持哪些设备观看？',
    a: '7777影院支持电脑、平板和手机浏览器直接访问，也提供iOS和Android APP下载。所有设备均自动适配屏幕尺寸，无需额外设置。APP还支持离线缓存功能，无网络也能观看。',
    icon: 'ri-device-line',
  },
  {
    q: '视频画质最高支持多少？',
    a: '7777影院大部分影视资源支持1080P高清画质，部分新片支持4K超清画质。播放时可在播放器设置中选择不同清晰度，系统会根据您的网络状况自动推荐最佳画质。',
    icon: 'ri-hd-line',
  },
  {
    q: '资源多久更新一次？',
    a: '7777影院片库每日更新，平均每天新增50+部影视内容。热门电影通常在院线下映后1-2周内上线，热播电视剧一般当天或次日更新最新集数，综艺节目播出后2小时内更新。',
    icon: 'ri-refresh-line',
  },
  {
    q: '如何反馈问题或投稿内容？',
    a: '您可以通过「联系我们」板块的邮箱提交内容投稿或问题反馈。我们会在2小时内回复。如果您想推荐某部影视作品上线，也欢迎发送片名至投稿邮箱，我们会尽快评估并安排上线。',
    icon: 'ri-mail-send-line',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950">
            常见问题
          </h2>
          <p className="mt-3 text-sm text-foreground-500">关于7777影院你想知道的一切</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqs.map((item) => (
            <div key={item.q} className="bg-background-50 rounded-xl p-5 md:p-6">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-lg bg-primary-50 flex items-center justify-center shrink-0 mt-0.5">
                  <i className={`${item.icon} text-sm text-primary-600 w-4 h-4 flex items-center justify-center`}></i>
                </div>
                <div>
                  <h3 className="font-heading font-semibold text-base text-foreground-900 mb-2">
                    {item.q}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.a}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}